import { CSSVariableConfig } from '../services/global-css-variables.service';

/**
 * Konfiguration für alle CSS-Variablen, die automatisch überwacht werden sollen
 * 
 * Um eine neue CSS-Variable hinzuzufügen, fügen Sie einfach ein neues Objekt zu diesem Array hinzu:
 * 
 * {
 *   name: '--meine-variable',
 *   selector: '.meine-klasse',
 *   property: 'offsetHeight',
 *   unit: 'px'
 * }
 */
export const CSS_VARIABLES_CONFIG: CSSVariableConfig[] = [
  // Ion Header Höhe
  {
    name: '--ion-header-height',
    selector: 'ion-header',
    property: 'offsetHeight',
    unit: 'px'
  },
  
  // Ion Toolbar Höhe
  {
    name: '--ion-toolbar-height',
    selector: 'ion-toolbar',
    property: 'offsetHeight',
    unit: 'px'
  },
  
  // Ion Tab Bar Höhe
  {
    name: '--ion-tab-bar-height',
    selector: 'ion-tab-bar',
    property: 'offsetHeight',
    unit: 'px'
  },
  
  // Ion Footer Höhe
  {
    name: '--ion-footer-height',
    selector: 'ion-footer',
    property: 'offsetHeight',
    unit: 'px'
  },
  
  // Beispiel: Sidebar Breite (falls vorhanden)
  // {
  //   name: '--sidebar-width',
  //   selector: '.sidebar',
  //   property: 'offsetWidth',
  //   unit: 'px'
  // },
  
  // Beispiel: Navigation Höhe
  // {
  //   name: '--nav-height',
  //   selector: '.main-navigation',
  //   property: 'offsetHeight',
  //   unit: 'px'
  // },
  
  // Beispiel: Content Padding (berechnet)
  // {
  //   name: '--content-padding-top',
  //   selector: 'ion-content',
  //   property: 'offsetTop',
  //   unit: 'px'
  // }
];

/**
 * Verfügbare Properties für CSS-Variablen:
 * - offsetHeight: Gesamthöhe inklusive Border und Padding
 * - offsetWidth: Gesamtbreite inklusive Border und Padding
 * - clientHeight: Höhe ohne Border, mit Padding
 * - clientWidth: Breite ohne Border, mit Padding
 * - scrollHeight: Gesamthöhe des scrollbaren Inhalts
 * - scrollWidth: Gesamtbreite des scrollbaren Inhalts
 * - offsetTop: Abstand vom oberen Rand des Viewports
 * - offsetLeft: Abstand vom linken Rand des Viewports
 */

/**
 * Verfügbare Einheiten:
 * - 'px' (Pixel)
 * - 'rem' (Root Em)
 * - 'em' (Em)
 * - '%' (Prozent)
 * - 'vh' (Viewport Height)
 * - 'vw' (Viewport Width)
 * - '' (keine Einheit)
 */
